import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar.js";
import AdminFooter from "./AdminFooter.js";
import AdminHeader from "./AdminHeader.js";
import {
  server_post_data,
  get_all_amenities,
  save_update_amenities,
  get_all_master_amenities,
} from "../../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  handleAphabetsChange,
  handleEmailChange,
  handleIaphabetnumberChange,
  handleNumbersChange,
  handlePasswordChange,
  handleSuccessSession,
  handleError,
  computeTodayDate,
  computeFutureDate,
} from "../../CommonJquery/CommonJquery.js";
import { useLocation, Link, useParams } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
function AmenitiesVenueAdd() {
  const { id, eid } = useParams();
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editBlogData, seteditBlogData] = useState([]);
  const [editOldImageData, seteditOldImageData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const retrievedAdminId = retrieveData("staff_id");
  const [dynaicimage, setDynaicimage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedValue, setSelectedValue] = useState("0");
  const [selectedValue1, setSelectedValue1] = useState("0");
  const [masterAmenities, setMasterAmenities] = useState();
  const [Amenities, setAmenities] = useState();
  // const handleTogglePassword = () => {
  //   setShowPassword(!showPassword);
  // };

  useEffect(() => {
    const flag = "3";
    let call_id = eid;
    master_data_get(flag, call_id);
  }, []);

  const master_data_get = async (flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("admin_id", retrievedAdminId);
    fd.append("flag", flag);
    fd.append("main_id", call_id);
    await server_post_data(get_all_amenities, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditBlogData(Response.data.message[0]);
          setEditorDatMainID(Response.data.message[0].primary_id);
          seteditOldImageData(Response.data.message[0].image);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get1();
  }, []);
  const master_data_get1 = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", 1);
    await server_post_data(get_all_master_amenities, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log(Response.data.message);
          // if (Response.data.message) {
          setMasterAmenities(Response.data.message.master_amenities);
          setAmenities(Response.data.message.Amenities_official);
          // setSelectedValue(Response.data.message[0].amenities_id);
          // }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };
  console.log(selectedValue);
  console.log(selectedValue1);
  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, dynaicimage);
      fd_from.append("admin_id", retrievedAdminId);
      fd_from.append("main_id", editorDataMainID);
      fd_from.append("admin_image", editOldImageData);
      fd_from.append("call_id", id);
      fd_from.append("amenities_data", selectedValue);
      fd_from.append("amenities_id", selectedValue1);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          console.log(Response.data.message);
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(
              Response.data.message,
              `/VenueDeshboardEdit/${id}/AmenitiesVenueView`
            );
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };
  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
  };
  const handleSelectChange1 = (event) => {
    const newValue = event.target.value;
    setSelectedValue1(newValue);
  };
  const handleFileChangedynamic = (keyname) => (event) => {
    const file = event.target.files[0];

    let new_file_name = keyname + "_show";

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setDynaicimage((prevImages) => ({
          ...prevImages,
          [keyname]: file,
          [new_file_name]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setDynaicimage((prevImages) => ({
        ...prevImages,
        [keyname]: null,
        [new_file_name]: null,
      }));
    }
  };

  return (
    <div className="app-container app-theme-white body-tabs-shadow fixed-header">
      <div className={showLoaderAdmin ? "loading_website" : ""}></div>
      <AdminHeader />

      <div className="app-main">
        <AdminSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className="app-page-title">
              <div className="page-title-wrapper">
                <div className="page-title-heading">
                  <Link to="/admindashboard">
                    <div className="page-title-icon">
                      <i className="fa fa-home icon-gradient bg-mean-fruit"></i>
                    </div>
                  </Link>
                  <div>
                    Venue Amenitie Management
                    <div className="page-title-subheading">
                      Add and Edit Venue Amenitie
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-card mb-3 card">
              <div className="card-body">
                <h5 className="card-title">Add/Edit Venue Amenitie</h5>
                <form className="needs-validation" id="CarrerformData">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        type <span className="red_show">*</span>
                      </label>
                      <select
                        className="form-control trio_mandatory length_min"
                        name="amenities"
                        id="amenities"
                        value={selectedValue}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select Type</option>
                        {Amenities && Amenities.length > 0 ? (
                          Amenities.map((e) => (
                            <option value={e.Name}>{e.Name}</option>
                          ))
                        ) : (
                          <option value="">Data Not Found</option>
                        )}
                      </select>
                      <span className="condition_error"></span>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Amenities <span className="red_show">*</span>
                      </label>
                      <select
                        className="form-control trio_mandatory length_min"
                        name="master_amenities"
                        id="master_amenities"
                        value={selectedValue1}
                        onChange={handleSelectChange1}
                      >
                        <option value="">Select Type</option>
                        {masterAmenities && masterAmenities.length > 0 ? (
                          masterAmenities.map((e) => (
                            <option key={e.primary_id} value={e.primary_id}>
                              {e.master_amenities_name}
                            </option>
                          ))
                        ) : (
                          <option value="">Data Not Found</option>
                        )}
                      </select>
                      <span className="condition_error"></span>
                    </div>
                  </div>

                  {/* <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Images
                        <span style={{ color: "red", fontWeight: "600" }}>
                          (size 300*300 max)
                        </span>
                      </label>
                      <br></br>
                      <input
                        className="inputEditFile"
                        type="file"
                        name="admin_image"
                        onChange={handleFileChangedynamic("admin_image")}
                        accept=".jpg,.jpeg,.png"
                      />
                      <div className="previewEditBox">
                        {dynaicimage && dynaicimage.admin_image_show && (
                          <img
                            src={dynaicimage.admin_image_show}
                            alt="Preview"
                            className="imgEditMaster"
                          />
                        )}
                      </div>
                      <span className="condition_error"></span>
                    </div>
                  </div> */}
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() =>
                      handleSaveChangesdynamic(
                        "CarrerformData",
                        save_update_amenities
                      )
                    }
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
}
export default AmenitiesVenueAdd;
